// stores/useExperiences.ts

import { create } from "zustand";
import { convertToAddingExperience } from "@/lib/experiences/newExperience"; // Keep if still needed elsewhere
import {
  WaytoraExperienceInitial,
  ViatorProductInitial,
  AddingExperience, // Keep if still needed elsewhere
} from "@/types";

interface ExperienceStore {
  selectedExperienceId: string | null;
  setSelectedExperienceId: (id: string | null) => void;
  addingExperience: AddingExperience | null; // Removed
  setAddingExperience: (experience: AddingExperience | null) => void; // Removed
  waytoraExperience: WaytoraExperienceInitial | null;
  setWaytoraExperience: (
    waytoraExperience: WaytoraExperienceInitial | null
  ) => void;
  viatorProduct: ViatorProductInitial | null;
  setViatorProduct: (viatorProduct: ViatorProductInitial | null) => void;
  isModalOpen: boolean;
  setIsModalOpen: (isOpen: boolean) => void;
  handleOpenModal: (placeId: string) => void;
  shouldCloseModal: boolean;
  setShouldCloseModal: (shouldClose: boolean) => void;
  activeExperiencesTab: "activities" | "experiences" | "add-activity";
  setActiveExperiencesTab: (
    tab: "activities" | "experiences" | "add-activity"
  ) => void;
  selectedExperienceTabIndex: number;
  setSelectedExperienceTabIndex: (index: number) => void;
  handleConvertToAddingExperience: (
    experience: WaytoraExperienceInitial | ViatorProductInitial
  ) => void;
  addExperienceToDay: (
    experience: WaytoraExperienceInitial | ViatorProductInitial
  ) => void;
}

const useExperiencesStore = create<ExperienceStore>((set) => ({
  selectedExperienceId: null,
  setSelectedExperienceId: (id) => set({ selectedExperienceId: id }),
  addingExperience: null,
  setAddingExperience: (experience) => set({ addingExperience: experience }),
  waytoraExperience: null,
  setWaytoraExperience: (waytoraExperience) => set({ waytoraExperience }),
  viatorProduct: null,
  setViatorProduct: (viatorProduct) => set({ viatorProduct }),
  isModalOpen: false,
  setIsModalOpen: (isOpen) => set({ isModalOpen: isOpen }),
  handleOpenModal: (placeId) =>
    set({ isModalOpen: true, shouldCloseModal: false }),
  shouldCloseModal: false,
  setShouldCloseModal: (shouldClose) => set({ shouldCloseModal: shouldClose }),
  activeExperiencesTab: "activities",
  setActiveExperiencesTab: (tab) => set({ activeExperiencesTab: tab }),
  selectedExperienceTabIndex: 0,
  setSelectedExperienceTabIndex: (index) =>
    set({ selectedExperienceTabIndex: index }),

  handleConvertToAddingExperience: (experience) => {
    const addingExp = convertToAddingExperience(experience);
    set({ addingExperience: addingExp });
  },

  addExperienceToDay: (experience) => {
    const addingExp = convertToAddingExperience(experience);
    set({ addingExperience: addingExp });
  },
}));

export default useExperiencesStore;
